// settings for BI

export default {
  bi: (data) => {
    // eslint-disable-next-line
    console.log(`track this data:`, data);
  },
}



// WEBPACK FOOTER //
// ./src/helpers/trackers.js